import getSplitedPath from '@/services/functions/getSplitedPath'
function hasNestedValue (fieldName, dataItem, { checkNull = false, checkUndefined = false } = {}) {
  if (!fieldName) {
    return false
  }
  const path = getSplitedPath(fieldName)
  let parent = dataItem
  for (let i = 0; i < path.length; i++) {
    const key = path[i]
    if (parent === null || parent === undefined) {
      return false
    }
    if (!Object.hasOwnProperty.call(parent, key)) {
      return false
    }
    parent = parent[key]
  }
  return !((checkNull && parent === null) || (checkUndefined && parent === undefined))
}

export default hasNestedValue
